export const dateToString = (date: string): string => {
  return new Date(date).toLocaleString('ru', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}
